$(document).ready(function () {
    
    // For regularer CTAs to scroll to section
    const ctaButtons = document.querySelectorAll('.ctaBTN');
    // Attach click event to each button
    if(ctaButtons){
        ctaButtons.forEach(button => {
            button.addEventListener('click', event => {
                event.preventDefault(); // prevent default jump

                // Get href value (like "#shopTrioSection")
                const targetId = button.getAttribute('href');

                // Make sure it's a valid section id
                if (targetId && targetId.startsWith('#')) {
                const targetSection = document.querySelector(targetId);
                if (targetSection) {
                    // Smooth scroll to that section
                    targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                    });
                }
                }
            }); 
        });
    }

    //For header links
    const ctaLinks = document.querySelectorAll('.list-menu__item');
    if (ctaLinks.length) {
        ctaLinks.forEach(link => {
            link.addEventListener('click', event => {
            const targetId = link.getAttribute('href');

            if (!targetId || !targetId.startsWith('#')) return;

            const targetSection = document.querySelector(targetId);
            if (!targetSection) return;

            event.preventDefault();

            // Smooth scroll
            targetSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            // Close menu drawer
            const menuDrawer = document.querySelector(
                'details#Details-menu-drawer-container'
            );

            if (menuDrawer && menuDrawer.hasAttribute('open')) {
                // Delay feels better on mobile
                setTimeout(() => {
                    menuDrawer.classList.remove('menu-opening');
                    menuDrawer.removeAttribute('open');
                    menuDrawer.querySelector('summary').setAttribute('aria-expanded', 'false');

                }, 300);
            }
            });
        });
    }

    //for accordion
    let allAccordionsSection = document.querySelectorAll('.new-accordion-wrap');
    if(allAccordionsSection){
        allAccordionsSection.forEach((accordionWrap) => {
            const accordionHeaders = accordionWrap.querySelectorAll('.accordion-header');

            accordionHeaders.forEach((header) => {
                header.addEventListener('click', () => {
                    const item = header.parentElement;
                    const isActive = item.classList.contains('active');

                    // Close all items inside *this accordion only*
                    accordionWrap.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

                    // If this wasn't active before, open it
                    if (!isActive) {
                        item.classList.add('active');
                    }
                });
            });
        });
    }


     //Numbers Count function
    const section = document.querySelector(".new-numbers-with-text-wrap");
    if(section){

        const counters = section.querySelectorAll(".iwt-text");
        let hasAnimated = false;

        const startCount = () => {
            if (hasAnimated) return;
            hasAnimated = true;

            counters.forEach(counter => {
            const target = parseInt(counter.textContent.replace("%", ""), 10);
            let current = 0;
            const speed = 20; // lower = faster

            counter.textContent = "0%";

            const updateCount = () => {
                if (current < target) {
                current++;
                counter.textContent = current + "%";
                setTimeout(updateCount, speed);
                } else {
                counter.textContent = target + "%";
                }
            };

            updateCount();
            });
        };

        const observer = new IntersectionObserver(
            entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                startCount();
                observer.disconnect(); // run once only
                }
            });
            },
            {
            threshold: 0.5 // 50% visible
            }
        );

        observer.observe(section);
    }   

});//doc ready ends
